import { render, staticRenderFns } from "./VesselAdd.vue?vue&type=template&id=2e3803eb&scoped=true&"
import script from "./VesselAdd.vue?vue&type=script&lang=js&"
export * from "./VesselAdd.vue?vue&type=script&lang=js&"
import style0 from "./VesselAdd.vue?vue&type=style&index=0&id=2e3803eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3803eb",
  null
  
)

export default component.exports